// src/components/operationCenter/widgets/token/derivatives/TwExchangeFundingWidget.tsx
import React from "react";
import type { WidgetProps, TokenWidgetConfig } from "@/types/dashboard";
import { TokenWidgetWrapper } from "../TokenWidgetWrapper";
import { TokenWidgetConfigPanel } from "../TokenWidgetConfig";
import ExchangeFundingBreakdownCard from "@/components/tokenPage/derivatives/ExchangeFundingBreakdownCard";

const TwExchangeFundingWidget: React.FC<WidgetProps<TokenWidgetConfig>> = ({
  widget,
  onConfigChange,
}) => {
  const config = widget.config as TokenWidgetConfig;
  return (
    <TokenWidgetConfigPanel config={config} onConfigChange={onConfigChange} widgetType={widget.type}>
      <TokenWidgetWrapper ticker={config.ticker} providers={["derivatives"]}>
        <ExchangeFundingBreakdownCard ticker={config.ticker.toUpperCase()} />
      </TokenWidgetWrapper>
    </TokenWidgetConfigPanel>
  );
};

export default TwExchangeFundingWidget;
